import { gql } from 'react-apollo';

export default gql`
  query offer($_id: ID!) {
    offer(_id: $_id) {
      _id
      name
      status
      visibility
      repName
      crdNumber
      countDown
      locationsToExclude
      disclaimerText
      toggleDataRoom
      dataRoomId
      dataRoomGroupId
      dataRoomCreated
      hasJoinedWorkspace
      headerImageUrl
      offerPresentationTitle
      offerPresentationUrl
      stripeAccountId
      stripeProductId
      enableOfferPresentation
      headerType
      headerVideoId
      listingType
      sector
      amountRaise
      totalInvestors
      investmentInstrument
      area
      offerPassword
      minimumInvestment
      targetRaise
      offerCurrency
      valueRange
      assetStatus
      sharesForSale
      highlights
      primaryObjective
      netAcres
      typeOfOffer
      processType
      republicProcessType
      wefunderProcessType
      realexProcessType
      testWatersToggle
      externalUrlSwitch
      externalUrl
      county
      averageDailyProduction
      enableInvestment
      approved
      baseCurrency
      geographicMandate
      fundType
      domicileOption
      domicileOnshore
      domicileOnshoreFund_other
      domicileOffShore
      domicileOffShore_other
      systematicDiscretionaryOption
      investmentCoActExemptionOption
      investmentAdvisorType
      leverage
      fundStructure
      fundStrategyClassfication
      fundStrategyClassficationOne
      fundStrategyClassficationTwo
      fundStrategyClassficationThree
      aumfund
      fundCapacity
      trackRecordFund
      trackRecordFirm
      altOfferTitle
      paymentDetails {
        _id
        subscriptionAgreementDocumentId
        brokerageAgreementDocumentId
        pricePerShareOrToken
        acceptedPaymentMethod
        acceptedBankTypes
        acceptedCryptoTypes
        ethWalletAddress
        btcWalletAddress
        xlmWalletAddress
        xrpWalletAddress
        usdcWalletAddress
        tusdWalletAddress
        paxWalletAddress
        bankName
        bankAddress
        beneficiaryName
        swiftCode
        accountNumber
        routingNumber
        memoLine
        IRAUrl
      }
      documents {
        _id
        title
        url
        previewImageUrl
      }
      videoFiles {
        _id
        title
        url
        imageUrl
      }
      faqs {
        _id
        question
        answer
      }

      videoUrls
      issuerCompany {
        _id
        name
        logoUrl
        companyBackground
        isCompanyApproved
        users {
          _id
          fullName
          position
          biography
          isManagementUserApproved
          imageUrl
          order
        }
      }
      investorOffer {
        _id
        hasAccessedWorkspace
        favorited
      }
      cashFee
      securitiesCommission
      closingDate
      valuationCap
      maturity
      coupon
      discountRate
      isVanityUrl
      vanityUrl
      calendlyUrlSwitch
      calendlyUrl
      productDeveloper
      creditIssued
      product
      vintage
      region
      bypassDocusign
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/queries/offer.js